module.exports = __webpack_public_path__ + "static/media/iso_qr_code.87d4a39a.svg";